import Vue from 'vue'
import Vuex from 'vuex'

import user from './user'
import timesheet from './timesheet'
import shared from './shared'
import expenses from './expenses'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    user: user,
    timesheet: timesheet,
    shared: shared,
    expenses: expenses
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js